import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { BalanceDetailsResponseDTO } from '../models/BalanceDetailsResponseDTO';
import { BalanceRequestDTO } from '../models/BalanceRequestDTO';
import { BalanceResponseDTO } from '../models/BalanceResponseDTO';
import { Urls } from '../utilities/urls.component';
import { HttpHeadersService } from './http-headers.service';

@Injectable()
export class BalanceService {
  balancesubject = new Subject();
  // API_ENDPOINT:string;
  constructor(private http: HttpClient, private headers: HttpHeadersService) {
    // this.API_ENDPOINT=localStorage.getItem("ENDPOINT");
  }

  getBalanceList(request: BalanceRequestDTO) {
    var url: string = Urls.API_ENDPOINT + Urls.BALANCES.getAllBalance;
    return this.http.post<BalanceResponseDTO>(url, request, this.headers.getCommonHttpHeaders()).pipe(timeout(6000000));
  }

  getBalanceById(request: BalanceRequestDTO) {
    var url: string = Urls.API_ENDPOINT + Urls.BALANCES.getAllBalanceById;
    return this.http.post<BalanceDetailsResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
  }

  exportBalance(request: BalanceRequestDTO) {
    var url: string = Urls.API_ENDPOINT + Urls.EXPORTAS.balanceExcelExport;
    return this.http.post<any>(url, request, this.headers.getCommonHttpHeaders());
  }

  getBalanceListById(request: BalanceRequestDTO){
    var url: string = Urls.API_ENDPOINT + Urls.BALANCES.getBalanceListById;
    return this.http.post<BalanceResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    }
    getExportDataOnBalance(request: BalanceRequestDTO) {
      var url: string = Urls.API_ENDPOINT + Urls.BALANCES.getExportDataOnBalance;
      return this.http.post<BalanceResponseDTO>(url, request, this.headers.getCommonHttpHeaders());
    }

}
